import BaseApiService from './baseApiService';
import {
    FlightRoundsExportQuery,
    GetFlightRoundsQuery,
    GetFlightRoundsQueryFilter,
    ImportReportDataResult,
    Paginated,
    FlightRoundVM
} from '../contracts';
import { RcFile } from 'antd/lib/upload';

class FlightRoundApiService extends BaseApiService {
    loadFlightRound = async (query: GetFlightRoundsQuery) => {
        return await this.post<Paginated<FlightRoundVM>, GetFlightRoundsQuery>('report-data/flight-round', query);
    };

    uploadFlightRound = async (file: RcFile) => {
        const form = new FormData();
        form.append('file', file);
        return await this.post<ImportReportDataResult, FormData>('report-data/flight-round/import', form);
    };

    downloadFlightRound = async (filter: GetFlightRoundsQueryFilter) => {
        return await this.downloadFilePost<FlightRoundsExportQuery>('report-data/flight-round/export/tsv', { filter });
    };

    deleteFlightRound = (ids: number[]) => {
        return this.delete('report-data/flight-round', { data: { ids } });
    };
}

export default new FlightRoundApiService();
